module.exports = __webpack_public_path__ + "img/arrow-white.24ba17d6.svg";